import { render, staticRenderFns } from "./ServiceTranslationTag.vue?vue&type=template&id=035fbfee&"
import script from "./ServiceTranslationTag.vue?vue&type=script&lang=js&"
export * from "./ServiceTranslationTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports